<div class="grid-container grid-1">
    @if ((tilesConfig?.hasTileAdminAccess$ | async) || (tilesData && tilesData.length > 0)) {
        <div class="flex-header" [class.no-print]="tilesData?.length === 0" [class.header-without-card]="config.headerWithoutCard">
            <div>
                <developer-helper [datasourceCode]="OldDataSourceCode.IPE" />
                <div class="title word-wrap font-size-12em sse-titles-color">
                    {{ config.translations.widgetTitle }}
                </div>
                @if (config?.ignorePeriodsStore) {
                    <div class="sub-title word-wrap font-size-07em sse-titles-color">
                        {{ 'STUFF.FROM_DATE_SENTENCE' | translate }}
                        ({{ dateStart | dateFormat: dateFormat }}
                        {{ 'STUFF.TO_DATE' | translate }}
                        {{ dateEnd | dateFormat: dateFormat }})
                    </div>
                }
                @if (!config?.ignorePeriodsStore && period) {
                    <div class="sub-title word-wrap font-size-07em sse-titles-color">
                        @if (period.name === lastTwelveMonths) {
                            <span>{{ 'WIDGET.PERIOD_TWELVE_MONTHS' | translate }}</span>
                        }
                        @if (period.name !== lastTwelveMonths) {
                            <span>
                                {{ 'WIDGET.PERIOD_YEAR' | translate: { year: period.name | translatePeriod } }}
                            </span>
                        }
                    </div>
                }
            </div>
            <div>
                @if (!config.hideAddButton) {
                    <help-button class="no-print" [link]="helpButtonUrl" />
                }
                @if ((tilesConfig?.hasTileAdminAccess$ | async) && !config.hideAddButton) {
                    <ui-icon-button
                        iconName="create"
                        class="no-print"
                        [advizeoTooltip]="'WIDGET.HOME_TILES.ADD' | translate"
                        (click)="newTile()"
                    />
                }
            </div>
        </div>
    }

    @if (tilesData && tilesData.length > 0) {
        <div class="tile-grid">
            @for (tile of tilesData; track tile; let i = $index) {
                <div [ngClass]="getContainerClassForTileType(tile.tileType)">
                    <tile-spawner
                        class="height-100"
                        [tileData]="tile"
                        [tileConfig]="tilesConfig"
                        (deleted)="onTileDelete(i)"
                        (edited)="onTileEdit(i, $event)"
                    />
                </div>
            }
        </div>
    }
</div>
